import { render, staticRenderFns } from "./IconIdp.vue?vue&type=template&id=394936d6"
import script from "./IconIdp.vue?vue&type=script&lang=js"
export * from "./IconIdp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports